// extracted by mini-css-extract-plugin
export default {"products":"Hz-z","card":"Iz-z","oosMessaging":"Jz-z"};